// Query string for /reports/specialty-summary. Repeats visn / new_visn so the
// API can IN-filter every selected value instead of dropping multi-selects.
export const buildSpecialtySummaryQuery = ({ visn, new_visn } = {}) => {
  const params = new URLSearchParams();
  const appendAll = (key, values) => {
    const list = Array.isArray(values) ? values : values != null && values !== "" ? [values] : [];
    list.forEach((v) => {
      if (v != null && v !== "") params.append(key, v);
    });
  };
  appendAll("visn", visn);
  appendAll("new_visn", new_visn);
  return params.toString();
};
